/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResolutionData } from './ResolutionData';
import {
    ResolutionDataFromJSON,
    ResolutionDataFromJSONTyped,
    ResolutionDataToJSON,
    ResolutionDataToJSONTyped,
} from './ResolutionData';
import type { ResolutionHistoryEntry } from './ResolutionHistoryEntry';
import {
    ResolutionHistoryEntryFromJSON,
    ResolutionHistoryEntryFromJSONTyped,
    ResolutionHistoryEntryToJSON,
    ResolutionHistoryEntryToJSONTyped,
} from './ResolutionHistoryEntry';

/**
 * 
 * @export
 * @interface ProfileResolutionResponse
 */
export interface ProfileResolutionResponse {
    /**
     * 
     * @type {ResolutionData}
     * @memberof ProfileResolutionResponse
     */
    data?: ResolutionData;
    /**
     * 
     * @type {Array<ResolutionHistoryEntry>}
     * @memberof ProfileResolutionResponse
     */
    resolutionHistory?: Array<ResolutionHistoryEntry>;
    /**
     * 
     * @type {number}
     * @memberof ProfileResolutionResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileResolutionResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileResolutionResponse
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof ProfileResolutionResponse
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the ProfileResolutionResponse interface.
 */
export function instanceOfProfileResolutionResponse(value: object): value is ProfileResolutionResponse {
    return true;
}

export function ProfileResolutionResponseFromJSON(json: any): ProfileResolutionResponse {
    return ProfileResolutionResponseFromJSONTyped(json, false);
}

export function ProfileResolutionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileResolutionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ResolutionDataFromJSON(json['data']),
        'resolutionHistory': json['resolutionHistory'] == null ? undefined : ((json['resolutionHistory'] as Array<any>).map(ResolutionHistoryEntryFromJSON)),
        'page': json['page'] == null ? undefined : json['page'],
        'size': json['size'] == null ? undefined : json['size'],
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}

export function ProfileResolutionResponseToJSON(json: any): ProfileResolutionResponse {
    return ProfileResolutionResponseToJSONTyped(json, false);
}

export function ProfileResolutionResponseToJSONTyped(value?: ProfileResolutionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ResolutionDataToJSON(value['data']),
        'resolutionHistory': value['resolutionHistory'] == null ? undefined : ((value['resolutionHistory'] as Array<any>).map(ResolutionHistoryEntryToJSON)),
        'page': value['page'],
        'size': value['size'],
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}

